<template>
  <div>
    <div class="btn">
      <RadioGroup v-model="animal">
        <Radio label="列表"></Radio>
        <Radio label="地图"></Radio>
      </RadioGroup>
      <Button type="primary" @click="exportTable">导出设备库存</Button>
    </div>
    <div class="lb" v-if="animal=='列表'">
      <div class="query">
        <div class="checkbox">
          <!-- <p style="width: 100px;">查询条件</p>
          <CheckboxGroup v-model="wd">
            <span>温度：</span>
            <Checkbox label="常温"></Checkbox>
            <Checkbox label="冷藏"></Checkbox>
          </CheckboxGroup>
          <CheckboxGroup v-model="zt">
            <span>状态：</span>
            <Checkbox label="启用"></Checkbox>
            <Checkbox label="禁用"></Checkbox>
          </CheckboxGroup>
          <CheckboxGroup v-model="gz">
            <span>是否故障：</span>
            <Checkbox label="正常"></Checkbox>
            <Checkbox label="故障"></Checkbox>
          </CheckboxGroup> -->
        </div>
        <Input search enter-button placeholder="请输入地址/编号查询" v-model="query.like" style="width: 500px;"
               @on-search="onsearch"/>
      </div>

      <Table border ref="selection" :columns="columns12" :data="data6" @on-selection-change="selection"
             :loading="loading">

        <template slot-scope="{ row, index }" slot="action">
          <Button type="primary" size="small" style="margin-right: 5px" @click="aisle(row)">货道信息</Button>
          <Button type="primary" size="small" style="margin-right: 5px" @click="equipmentUpdate(row)"
                  v-show="empType==4">修改负责人
          </Button>
          <!-- <Button type="primary" size="small" style="margin-right: 5px" @click="aisle(row.id)">故障信息</Button> -->
          <Button type="warning" size="small" style="margin-right: 5px" @click="aisle1(row)">并道</Button>
        </template>
      </Table>
      <div class="my-page">
        <page :total="total" v-if="showPage" @updatePage="updatePage" @updateSize="updateSize"></page>
      </div>
    </div>
    <div class="ditu" v-else>
      <ditu :zxd="zxd" :qt="qt" h="600px"></ditu>
    </div>
    <Modal
      v-model="uploadDialogVisible"
      title="上传图片"
      @on-visible-change="handleVisibleChange">
      <div>
        <h3>上传Logo</h3>
        <Upload
          ref="logo"
          type="drag"
          :action=url
          :format="['jpg','jpeg','png']"
          :max-size="2048"
          :on-success="handleLogoUploadSuccess"
          :on-error="handleLogoUploadError"
          :on-change="handleLogoUploadChange"
          style="margin-bottom: 20px;">
          <div style="padding: 20px 0">
            <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
            <p>点击或拖拽上传Logo</p>
          </div>
        </Upload>
      </div>
      <div>
        <h3>上传Adv图</h3>
        <Upload
          ref="adv"
          type="drag"
          :action=url
          :format="['jpg','jpeg','png']"
          :max-size="2048"
          :on-success="handleAdvUploadSuccess"
          :on-error="handleAdvUploadError"
          :on-preview="handlePreview"
          :on-change="handleAdvUploadChange">
          <div style="padding: 20px 0">
            <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
            <p>点击或拖拽上传Adv图</p>
          </div>
        </Upload>
      </div>
      <div slot="footer">
        <Button @click="uploadDialogVisible = false">取消</Button>
        <Button type="primary" @click="confirmUpload">确定</Button>
      </div>
    </Modal>

    <Modal
      v-model="isShow"
      @on-ok="asyncOK" class="fontsize">
      <p style="text-align: center;">记录:{{ gzQuestion }}</p>
    </Modal>
  </div>
</template>
<script>
// js内容
import http from '@/http/http.js'
import page from '@/components/comm/page.vue'
import ditu from '@/components/comm/ditu/ditu.vue'

export default {
  data() {
    return {
      isShow: false,
      gzQuestion: '',
      showPage: true,
      loading: false,
      empType: '',
      macLeaveFactory: {},
      animal: '列表',
      // 地图
      zxd: [106.49275526969987, 29.61166095192132], // 中心点坐标
      qt: [
        /* {position: [121.5263285, 31.21415044],id:1,url:'alliance/mac/aisle/list',address:'测试地址',code:'s-12'},
        {position: [121.5273285, 31.29415044],id:1,url:'alliance/mac/aisle/list',address:'测试地址',code:'s-12'} */
      ],
      // 地图
      // 选中的数据
      selectionData: [],
      // 查询条件
      wd: [],
      zt: [],
      gz: [],
      // 总页数
      total: 100,
      url: http.url + '/file/img/com',
      uploadDialogVisible: false,
      currentRowIndex: null,
      uploadimg: {
        logo: '',
        adv: '',
        macId: ''
      },
      columns12: [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          title: '设备编号',
          width: 120,
          align: 'center',
          key: 'id'
        },
        {
          title: '名称',
          width: 150,
          align: 'center',
          key: 'macDetailsName'
        },

        {
          title: '分类',
          width: 150,
          align: 'center',
          key: 'macKindstString'
        },
        {
          title: '位置',
          width: 200,
          align: 'center',
          key: 'address'
        },
        {
          title: '设备标识',
          width: 200,
          align: 'center',
          key: 'uuid1'
        },
        {
          title: '启用/停用',
          key: 'startUsing',
          width: 150,
          align: 'center',
          render: (h, params) => {
            if (params.row.startUsing == true) {
              return h('div', '启用')
            } else {
              return h('div', {style: {color: 'red'}}, '停用')
              /* return h('div',{style:{color:'red'}},[h('p','停用')]) */
            }
          }
        },
        {
          title: '设置logo',
          key: 'startUsing',
          width: 150,
          align: 'center',
          render: (h, params) => {
            return h('Button', {
              on: {
                click: () => {
                  this.showUploadDialog(params)
                }
              }
            }, '上传图片')
          }
        },

        {
          title: '设备状态',
          width: 150,
          align: 'center',
          key: 'state',
          render: (h, params) => {
            if (params.row.state == true) {
              return h('div', {
                style: {cursor: 'pointer', borderBottom: '1px solid #888', width: '24px', margin: '0 auto'},
                on: {
                  click: () => {
                    http.http({
                      method: 'post',
                      url: http.url + '/fac/mac/fault/details/newest',
                      data: {
                        id: params.row.id
                      },
                      success: (data) => {
                        if (data.code == 200) {
                          this.gzQuestion = data.data
                          this.isShow = true
                        }
                      }
                    })
                  }
                }
              }, '正常')
            } else {
              return h('div', {
                style: {
                  color: 'red',
                  cursor: 'pointer',
                  borderBottom: '1px solid #888',
                  width: '24px',
                  margin: '0 auto'
                },
                on: {
                  click: () => {
                    http.http({
                      method: 'post',
                      url: http.url + '/fac/mac/fault/details/newest',
                      data: {
                        id: params.row.id
                      },
                      success: (data) => {
                        if (data.code == 200) {
                          this.gzQuestion = data.data
                          this.isShow = true
                        }
                      }
                    })
                  }
                }
              }, '故障')
            }
          }
        },
        {
          title: '是否缺货',
          width: 150,
          align: 'center',
          key: 'stockout',
          render: (h, params) => {
            if (params.row.stockout == true) {
              return h('div', {style: {color: 'red'}}, '缺货')
            } else {
              return h('div', '正常')
            }
          }
        },
        {
          title: '责任人',
          width: 150,
          align: 'center',
          key: 'operEmpName'
        },
        {
          title: '所属片区',
          width: 150,
          align: 'center',
          key: 'districtName'
        },
        {
          title: '操作',
          slot: 'action',
          width: 250,
          fixed: 'right',
          align: 'center'
        }
      ],
      data6: [
        /* {
        id: '1',
        name: 'XXX机器人',
        address: '渝北区泰山大道东段',
        isRefrigerate: '冷藏',
        startUsing: '启用',
        state: '正常',
        isStockout: '正常',
        useOperOperator: "XXXX",
        createdTime: '2010-10-10'
      } */
      ],
      query: {
        page: '0',
        size: '10',
        like: ''
      },
      macId: {
        macIds: []
      }
    }
  },
  methods: {
    asyncOK() {
      this.isShow = false
    },
    aisle1(row) { // 货道药品信息
      this.$router.push({
        name: 'oper/mac/aisle/list11',
        query: {
          id: row.id
        }
      })
    },
    equipmentUpdate(item) {
      this.$router.push({
        name: 'oper/mac/emp/update',
        query: {
          operMacId: item.id,
          operEmpId: item.operEmpId,
          operEmpName: item.operEmpName
          /* machineCode: item.machineCode,
          macName: item.macName,
          empId:item.empDto.id */

        }
      })
    },
    onsearch() {
      let _this = this
      this.query.page = 0

      this.showPage = false
      this.$nextTick(() => {
        this.showPage = true
      })
      _this.ajaxPage()
    },
    aisle(row) { // 货道商品信息
      this.$router.push({
        name: 'oper/mac/aisle/list',
        query: {
          id: row.id
        }
      })
    },
    updatePage(page) { // 页码改变的回调，返回改变后的页码
      this.query.page = page - 1
      this.ajaxPage()
    },
    updateSize(size) { // 切换每页条数时的回调，返回切换后的每页条数
      this.query.size = size
      this.ajaxPage()
    },
    ajaxPage() {
      this.loading = true
      let _this = this
      http.http({
        // 这里是你自己的请求方式、url和data参数
        method: 'post',
        url: http.url + '/fac/mac/leave/factory/page/oper',
        data: _this.query,
        _this: _this,
        success: function (data) {
          _this.total = data.macFaultDetailss.totalElements
          _this.data6 = data.list

          _this.loading = false
        }
        // 假设后台需要的是表单数据这里你就可以更改
      })
    },
    ajaxPageDitu() {
      this.loading = true
      let _this = this
      http.http({
        // 这里是你自己的请求方式、url和data参数
        method: 'post',
        url: http.url + '/fac/mac/leave/factory/page/oper',
        data: {page: 0, size: 1000},
        _this: _this,
        success: function (data) {
          let a = data.list
          console.log(a)
          for (var i = 0; i < a.length; i++) {
            let latitude = parseFloat(a[i].latitude)
            let longitude = parseFloat(a[i].longitude)
            let b = {
              position: [longitude, latitude],
              id: a[i].id,
              url: 'aisle/list',
              address: a[i].address,
              code: a[i].macCode
            }

            _this.qt.push(b)
          }
        }
        // 假设后台需要的是表单数据这里你就可以更改
      })
    },
    selection(data) { // 多选按钮发生变化的回调
      this.selectionData = data
      this.selectionData = this.$refs.selection.getSelection()
    },
    cold() { // 设置常温或者冷藏

    },
    start() { // 启用或者停用设备
    },
    exportTable() {
      if (this.selectionData.length !== 0) {
        let mac = this.$refs.selection.getSelection()
        let _this = this
        let macId = []
        let alldata = []
        for (let i = 0; i < mac.length; i++) {
          macId.push(mac[i].id)
        }
        http.http({
          method: 'post',
          url: http.url + '/fac/mac/leave/factory/inventory',
          dataType: 'json',
          data: {'macIds': macId},
          _this: _this,
          success: function (res) {
            console.log(res)
            alldata = res.data
            _this.loading = false
            require.ensure([], () => {
              const {export_json_to_excel} = require('../../../../excel/Export2Excel.js')
              const tHeader = ['商品id', '商品名称', '规格', '厂家', '当前数量', '最大数量', '可补货数量', '待出货数量']
              const filterVal = ['commId', 'commName', 'specification', 'operCommManu', 'currentNumber', 'maxNumber', 'replenishmentNumber', 'currentNumber1']
              let listfix = []
              alldata.forEach((item, index) => {
                if (item.commName) {
                  let obj = {
                    'commId': item.commId,
                    'commName': item.commName,
                    'specification': item.specification,
                    'operCommManu': item.operCommManu,
                    'currentNumber': item.currentNumber,
                    'maxNumber': item.maxNumber,
                    'replenishmentNumber': item.replenishmentNumber,
                    'currentNumber1': item.currentNumber1
                  }
                  listfix.push(obj)
                }
              })
              const list = [...listfix]
              const data = _this.formatJson(filterVal, list)
              export_json_to_excel(tHeader, data, macId + '设备上的数据')
            })
          }
        })
      } else {
        this.$Message.info('请选择设备')
      }
    },
    formatJson(filterVal, jsonData) { // 这里必须写
      return jsonData.map(v => filterVal.map(j => v[j]))
    },

    showUploadDialog(index) {
      this.currentRowIndex = index.index
      this.uploadimg.macId = index.row.id
      console.log(this.uploadimg)
      console.log(index)
      this.uploadDialogVisible = true
    },
    handleLogoUploadSuccess(response, file, fileList) {
      // 处理Logo上传成功
      console.log(response)
      let _this = this
      _this.uploadimg.logo = response.url
      http.http({
        // 这里是你自己的请求方式、url和data参数
        method: 'post',
        url: http.url + '/fac/mac/leave/factory/updataPic',
        data: _this.uploadimg,
        success: function (data) {
          if (data.code === 200) {
            this.$Message.success('上传成功！')
          } else {
            this.$Message.error('上传成功！')
          }
        }
      })
    },
    handleLogoUploadError(error, file, fileList) {
      // 处理Logo上传错误
      this.$Notice.error({
        title: '上传失败',
        desc: true
      })
    },
    handleLogoUploadChange(file, fileList) {
      // 处理Logo上传改变
    },
    handleAdvUploadSuccess(response, file, fileList) {
      console.log(response)
      // 处理Adv图上传成功
      let _this = this
      _this.uploadimg.adv = response.url
      http.http({
        // 这里是你自己的请求方式、url和data参数
        method: 'post',
        url: http.url + '/fac/mac/leave/factory/updataPic',
        data: this.uploadimg,
        success: function (data) {
          if (data.code === 200) {
            this.$Message.success('上传成功！')
          } else {
            this.$Message.error('上传成功！')
          }
        }
      })
    },
    handleAdvUploadError(error, file, fileList) {
      // 处理Adv图上传错误
      this.$Notice.error({
        title: '上传失败',
        desc: true
      })
    },
    handleAdvUploadChange(file, fileList) {
      // 处理Adv图上传改变
    },
    handlePreview(file) {

    },
    confirmUpload() {
      // 处理确定上传逻辑
      this.uploadDialogVisible = false
    }
  },
  components: {
    page, ditu
  },
  created() {
    this.empType = JSON.parse(sessionStorage.getItem('user')).type
    this.ajaxPage()
    this.ajaxPageDitu()
  }
}
</script>
<style scoped="scoped" lang="less">
.list-btn {
  margin-bottom: 20px;

}

.delete {
  /* background-color: red;
  color: #333333; */
}

.my-page {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

.query {
  display: flex;
  justify-content: space-between;
  margin: 20px 0px 20px 0px;
}

.checkbox {
  display: flex;
  justify-content: flex-end;
}

span {
  color: #007AFF;
}

.btn {
  margin: 20px;
}

/* .fontsize /deep/ .ivu-modal{
 .ivu-modal-footer{
  text-align: center !important;
}
} */

</style>



// WEBPACK FOOTER //
// src/components/oper/mac/list.vue